import Application from "../../Application";
import { IAuthenticationService } from "../../service/authentication/AuthenticationService";
import { ICredentialsService } from "../../service/authentication/CredentialsService";
import { IRouter } from "../../runtime/Router";
import { Errors } from "../../common/Constants";
import { ILanguageService } from "../../service/language/LanguageService";

export default class LoginInteractor {
  private application: Application;
  private authenticationService: IAuthenticationService;
  private credentialsService: ICredentialsService;
  private languageService: ILanguageService;
  private router: IRouter;

  constructor(
    application,
    authenticationService,
    credentialsService,
    languageService,
    router,
    userService
  ) {
    this.application = application;
    this.authenticationService = authenticationService;
    this.credentialsService = credentialsService;
    this.languageService = languageService;
    this.router = router;
  }

  async execute(
    username: string,
    password: string,
    verificationCode?: string,
    redirectRoute?: string
  ) {
    try {
      const { languageCode, roles, twoFactorAuthRequired } =
        await this.authenticationService.login(
          username,
          password,
          verificationCode
        );

      if (twoFactorAuthRequired) {
        this.credentialsService.setUsername(username);
        this.credentialsService.setPassword(password);
        await this.credentialsService.saveTwoFactorAuthToStorage(
          twoFactorAuthRequired
        );
        this.router.replace({
          pathname: "/verification",
          search: redirectRoute && `?redirect=${redirectRoute}`
        });
      } else {
        const userSelectedLanguageCode =
          await this.credentialsService.getLanguage();
        if (userSelectedLanguageCode) {
          await this.languageService.changeLanguage(userSelectedLanguageCode);
        } else {
          await this.credentialsService.setLanguage(languageCode);
        }

        await this.credentialsService.saveRolesToStorage(roles);

        this.credentialsService.setIsLoggedIn(true);

        if (redirectRoute) {
          const splittedRoute = redirectRoute.split("?");
          this.router.replace({
            pathname: splittedRoute[0],
            search: splittedRoute[1]
          });
        } else {
          this.router.replace({
            pathname: this.application.applicationHome
          });
        }
      }
    } catch (error) {
      if (
        (error as any).message.substring(0, 1) ===
        Errors.EXPIRED_PASSWORD.toString()
      ) {
        return this.router.replace({
          pathname: "/change-password",
          state: {
            username,
            oldPassword: password
          }
        });
      }
      console.log(error);
      return error;
    }
  }
}
